import ReportDocument from "./ReportDocument";

const MISAdvances = ({ data = [] }) => {
  const columns = [
    { label: "Advance ID", key: "advance_id" },
    { label: "Purpose or Title", key: "title" },
    { label: "Date and Time", key: "created_at" },
    { label: "Recorded By", key: "submitted_by" },
    { label: "Reference", key: "reference_number" },
    { label: "Amount", key: "amount" },
    { label: "Cost center", key: "cost_center" },
    { label: "Project", key: "project" },
    { label: "Status", key: "status" },
  ];
  const customFields = data[0]?.custom_fields?.map((ele) => ele.key) ?? [];

  return (
    <ReportDocument
      columns={columns}
      data={data}
      customFields={customFields}
      orientation="landscape"
    />
  );
};

export default MISAdvances;
